export const environment = {
  apiUrl: "https://ekan-stg.konelayansabah.com/app/api/",
  apiCommerceUrl: "https://ekan-commerce.konelayansabah.com/api/",
  apiInventoryUrl: "https://ekan-payment.konelayansabah.com/api/",
  apiShipmentUrl: "https://ekan-shipment.konelayansabah.com/api/",
  apiFinanceUrl: "https://ekan-finance.konelayansabah.com/api/",
  shipmentVersion: "v2",
  version: "v1",
  enable_glitchtip: false,
  glitchtip_dsn: "",
};
